import { Row, Col } from "react-bootstrap";
// import profile_img from "../Images/profile_img.png";
// import Professionalprofile from "../Images/Professionalprofile.svg";
import { useNavigate } from "react-router-dom";
import client from "../../assets/img/client looking.svg";
import professional from "../../assets/img/professional looking.svg";

const SelectRole = () => {
  const navigate = useNavigate();
  localStorage.removeItem("professionalToken");
  localStorage.removeItem("professionalId");
  localStorage.removeItem("clientToken");
  localStorage.removeItem("clientId");
  localStorage.removeItem("clientData");
  localStorage.removeItem("professionalData");

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="custom_container d-flex flex-column align-items-center padding_top">
      <Row className="w-100 text-center">
        <Col>
          <h1 className="text-center join-heading form_head_text">
            Choose how you'd like to use SimpleRenovate
          </h1>
          {/* <p className="subtitle">
            Choose how you'd like to use SimpleRenovate
          </p> */}
        </Col>
      </Row>

      <Row className="mt-2 mt-md-0 g-md-5 g-3 ctm-signup-row">
        <Col sm={12} md={6}>
          <div className="card-container">
            <div className="card">
              <div className="profile_icon">
                <img src={client} alt="client" />
              </div>
              <h2 className="mt-3 professional-box">
                I’m looking for a quote.
              </h2>
              <p>
                Get matched with trusted renovation professionals and receive
                competitive quotes for your project.
              </p>
              <button
                className="btn btn-client"
                onClick={() => {
                  handleViewDetails();
                  navigate("/client/login");
                }}
              >
                Get Started
              </button>
            </div>
          </div>
        </Col>

        <Col sm={12} md={6}>
          <div className="card-container card-container-2">
            <div className="card">
              <div className="profile_icon">
                <img src={professional} alt="professional" />
              </div>
              <h2 className="mt-3 professional-box">
                I’m looking to bid on jobs.
              </h2>
              <p>
                Join our network of trusted professionals and grow your business
                with quality renovation projects.
              </p>
              <button
                className="btn btn-client"
                onClick={() => {
                  navigate("/professional/login");
                  handleViewDetails();
                }}
              >
                Get Started
              </button>
            </div>
          </div>
        </Col>

        <Row className="my-3 message_list_head_fixed">
          <Col xs={12} className="d-flex justify-content-center"></Col>
          {/* <p className="mt-4 text-center already_account_text">
            Already have an account?
            <span> Login</span>
          </p> */}
        </Row>
      </Row>
    </div>
  );
};

export default SelectRole;
